import React from 'react';

export default function About() {
  return (
<section id="about" className="py-6 px-6">
  <div className="slide-border-wrapper max-w-5xl mx-auto">
    <div className="slide-border-inner">
      <h3 className="text-3xl font-bold mb-4">About Me</h3>
      <p className="text-gray-400">
  I'm a passionate problem solver who enjoys building fast, accessible digital experiences across all kinds of technologies. Whether it's code or real-life challenges, I love breaking things down, thinking creatively, and continuously improving. I'm always exploring new tools and techniques to stay curious, grow smarter, and build better.
</p>
    </div>
  </div>
</section>
  );
}
